import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/historytakingcmr/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/historytakingcmr/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/historytakingcmr/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/historytakingcmr/submit',
    method: 'post',
    data: row
  })
}

